import React from 'react';
import { logActiveElement } from '../utils';

export const KeyboardTester = (props: any) => {
	const log = (e: any) => setTimeout(() => logActiveElement(e)); // Delayed log fn

	React.useEffect(() => {
		(document.querySelector('a.focusable-1') as any)?.focus(); // Autofocus

		if (props.logOnEvent) {
			document.addEventListener('click', log);
			document.addEventListener('keydown', log);
			return () => {
				document.removeEventListener('click', log);
				document.removeEventListener('keydown', log);
			};
		}
	}, [props.logOnEvent]);

	return (
		<div className="KeyboardTestWrapper">
			<a role="button" tabIndex={0} className="focusable-1">
				first focusable
			</a>
			<div>{props.children}</div>
			<a role="button" tabIndex={0} className="focusable-2">
				last focusable
			</a>
		</div>
	);
};
